module.exports = __webpack_public_path__ + "d0e239c57d5d933c733d227e32737ca8.png";